import type { CSSProperties, JSX } from 'react';
import { Toaster as SonnerToaster } from 'sonner';

/**
 * Un seul montage dans `main.tsx` (`02` §0 : « toast de succès ou d'erreur »).
 * Les appels se font via `src/lib/toast.ts`, jamais en important `sonner`
 * directement ailleurs — ce qui garantit un seul point de vérité pour le
 * style et le comportement des toasts.
 *
 * Surface neutre (tokens `popover`) ; seule l'icône porte la teinte du statut.
 */
const TOASTER_STYLE = {
  '--normal-bg': 'var(--color-popover)',
  '--normal-text': 'var(--color-popover-foreground)',
  '--normal-border': 'var(--color-border)',
  '--border-radius': 'var(--radius-lg)',
} as CSSProperties;

export function Toaster(): JSX.Element {
  return (
    <SonnerToaster
      position="top-right"
      closeButton
      theme="system"
      style={TOASTER_STYLE}
      toastOptions={{
        classNames: {
          toast: 'font-sans !shadow-popover !gap-2.5 !text-sm',
          description: '!text-muted-foreground',
          success: '[&_[data-icon]]:text-status-green-fg',
          error: '[&_[data-icon]]:text-status-red-fg',
          warning: '[&_[data-icon]]:text-status-orange-fg',
          info: '[&_[data-icon]]:text-status-blue-fg',
          closeButton: '!border-border !bg-popover !text-muted-foreground hover:!text-foreground',
        },
      }}
    />
  );
}
